import React from "react";
import CreateGroupMenu from "../../components/GroupMenu/CreateNewGroupMenu";
const index = () => {
  return (
    <div>
      <CreateGroupMenu />
    </div>
  );
};

export default index;
